import RelatorioViatura from '../views/RelatorioViaturas/Table.vue'

let routes = {
    path: '/relatorio-viaturas',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '',
            name: 'list-relatorio-viaturas',
            component: RelatorioViatura,
            meta: {
                pageTitle: 'Relatório de Viaturas',
                breadcrumb: [
                    {
                        text: 'Relatório de Viaturas',
                        active: true,
                    },
                ],
            },
        },
    ]
};

export default routes
